import { render, staticRenderFns } from "./ManageOkrs.vue?vue&type=template&id=79a47b2d&scoped=true"
import script from "./ManageOkrs.vue?vue&type=script&lang=js"
export * from "./ManageOkrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a47b2d",
  null
  
)

export default component.exports